<template>

    <loader v-if="!loaded"></loader>
    <router-view
        v-else
        @updateUserData="getUserData"
    ></router-view>

</template>

<script>

import axios from 'axios';
import { mapActions } from 'vuex';
import Loader from "../../../components/Common/Loader";

export default {

    components: {
        Loader,
    },

    data() {
        return {
            loaded:false,
        }
    },

    destroyed(){
        this.setHrUser({});
    },

    methods: {
        ...mapActions([
            'setHrUser',
        ]),

        getUserData() {
            axios.get(this.route('api.v1.hr.users.show', {id: this.$route.params.uuid}))
                .then(resp => {
                    this.setHrUser(resp.data.data);
                    this.loaded = true;
                });
        },
    },

    mounted(){
        this.getUserData();
    },

    name:'HrUsersLayout',

}

</script>
